// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-create-plant-line{\n    min-width: 550px;\n}\n.input-name-line-plant{\n    min-width: 319px;\n}", "",{"version":3,"sources":["webpack://src/components/general/line/modals/modalCreate.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".modal-create-plant-line{\n    min-width: 550px;\n}\n.input-name-line-plant{\n    min-width: 319px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
